<ng-container *transloco="let t; read: 'ime.manufacturing.item-log'">
  <form>
    <div class="modal-header d-print-none bg-white p-3" ngxModalDraggable>
      <h3 class="modal-title pull-left">
        {{itemsQuery.selectEntity(id) | async | displayName}}
      </h3>
      <button type="button" class="btn-close ms-auto" aria-label="Close" (click)="bsModalRef.dismiss()">
      </button>
    </div>
    <div class="modal-body">
      <app-item-log [itemId]="id" [context]="context"></app-item-log>
    </div>
  </form>
</ng-container>
